<template>
    <dashboard-layout>

      <template v-if="fetchDataLoading">
        <div class="big-white-card2">
          <center><div class="loader"></div></center>
        </div>
            </template>
            <template v-else>

      <div v-if="!withData">
        <div class="big-white-card2">
      <div class="center-content2">
        <img class="custom-icon-size" src="@/components/img/Sales_Assests/big-bank.svg" alt="Custom Icon">
        <p class="write-up">
          No uploaded bank merchants yet
        </p>
        <div class="subhead-text2">You are yet to upload a bank merchant list on the Swwipe</div>
        <div class="subhead-text2">Management System. Once uploaded, the list will be</div>
        <div class="subhead-text2">displayed here.</div>

        <!-- <button class="onboard-button" @click="openOnboardingModal0">Onboard A Merchant</button> -->
      </div>
      </div>
    </div>
    <div v-else>
      <div class="head-text3">Bank Merchants</div>
    <div class="subhead-text3">All Bank merchants uploaded on SMS will be listed here.</div>
    <div class="big-card">
      <div class="horizontal-container">
        <!-- Dropdown -->

        <div style="display: flex">
        <!-- <div class="dropdown-container">
              <select
                id="cardSwitch"
                class="form-control"
                v-model="cardSwitch"
                ref="dropdown"
                @change="handleCardSwitch"
                :disabled="disableDropdown"
                style="font-size: 12px; background-color: transparent;  cursor: pointer; z-index: 2; width: 120px; height: 35px;  color: #000; font-size: 13px; border: 1px solid #D1D5DB;"
              >
                <option value="Onboarded" selected>Onboarded</option>
                <option value="Pending">Pending</option>
              </select>
              <div v-if="cardSwitch == 'Onboarded' && pendingData.length != 0 || cardSwitch == 'Pending' && onboardedData.length != 0">
              <div class="dropdown-icon-container" >
                <img src="@/components/img/Sales_Assests/dropdown.svg" alt="Dropdown Icon" @click="toggleDropdown">
              </div>
            </div>
            </div> -->

        <!-- Search bar -->
        <div class="search-bar" style=" max-width: 500px;">
        <div class="search-icon ">
          <img src="@/components/img/Sales_Assests/Search.svg" alt="Search Icon" style="padding-right: 10px;">
        </div>
    <input type="text" class="form-control ml-1" v-model="searchTerm"  style="width: 370px; height: 35px; color:#000; font-size: 13px; border: 1px solid #D1D5DB;" placeholder="  Search with Merchant ID or Name...">
      </div>
   
  </div>
        <!-- Onbaord Button--> 
        <!-- <div class="button-container" style="margin-left: 210px; height: 35px; ">
          <button class="onboard-button2" @click="openOnboardingModal0">Onboard New Merchant</button>
        </div> -->
      </div><hr>


      <div class="custom-table-container" :key="currentPage">
    <table class="custom-table">
      <thead>
        <tr>
          <th style="white-space: nowrap;">Date Uploaded</th>
          <th style="white-space: nowrap;">Merchant ID</th>
          <th style="white-space: nowrap;">Full Name</th>
          <th style="white-space: nowrap;">Business Name</th>
          <th style="white-space: nowrap;">Phone Number</th>
          <th>Provider</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="fetchPageData">
            <tr>
            <center><div class="loaderPage"></div></center>
        </tr>
        </template>
        <template v-else>
        <template v-if="filteredRows.length === 0">
          <tr>
            <td colspan="7" style="text-align: center;">No records found</td>
          </tr>
        </template>
        <template v-else-if="searchTerm && filteredRows.length > 0" >
          <tr v-for="(row, index) in filteredRows" :key="index" class="table-row" @click="openContinueModal(row)">
            <td style="white-space: nowrap;">{{ formatDate(row.dateCreated) }}</td>
            <td style="white-space: nowrap;">{{ row.mid }}</td>
            <td style="white-space: nowrap;">{{ row.merchantName }}</td>
            <td style="white-space: nowrap;">{{ row.contactTitle }}</td>
            <td style="white-space: nowrap;">{{ row.mobilePhoneNo }}</td>
            <td style="white-space: nowrap;">{{ row.uploadedBy }}</td>
          </tr>
        </template>
        <template v-else>
          <tr v-for="(row, index) in visibleRows" :key="index" class="table-row" @click="openContinueModal(row)">
            <td style="white-space: nowrap;">{{ formatDate(row.dateCreated) }}</td>
            <td style="white-space: nowrap;">{{ row.mid }}</td>
            <td style="white-space: nowrap;">{{ row.merchantName }}</td>
            <td style="white-space: nowrap;">{{ row.contactTitle }}</td>
            <td style="white-space: nowrap;">{{ row.mobilePhoneNo }}</td>
            <td style="white-space: nowrap;">{{ row.uploadedBy }}</td>
          </tr>
        </template>
    </template>
      </tbody>
    </table>
    <div class="pagination">
      <span>{{ currentPageStart }} - {{ currentPageEnd }} of {{ totalRows }}</span>
      <img src="@/components/img/Sales_Assests/previousbutton.svg"
        class="pagination-icon1"
        alt="Prev Icon"
        @click="prevPage">
      <img src="@/components/img/Sales_Assests/nextbutton.svg"
        class="pagination-icon2"
        alt="Next Icon"
        @click="nextPage">
    </div>
    <hr>
      </div>
    </div>
    </div>

    <onboard-bank-merchants 
      v-if="showContinueModal" 
      :rowData="selectedRowData" 
      :showOnboardingModal0="showContinueModal"
      :forBankMerchants = true
      @close-modal="closeContinueModal"
      @close-modal3="closeContinueModal"
    >
    </onboard-bank-merchants>


    <!-- <onboarding-modal 
      :showOnboardingModal0="showOnboardingModal0" 
      :onboardButtonClicked="onboardButtonClicked" 
      @open-modal="openOnboardingModal0"  
      @close-modal="closeOnboardingModal0" 
      @close-modal1="closeOnboardingModal1" 
      @open-modal1="openOnboardingModal1"
      @continue-onboarding="openContinueModal"
      @reload-pending="fetchPendingOnboard"
      @reload-onboarded="fetchAllOnboardedMerchants"
    >
    </onboarding-modal> -->

    <!-- <continue-onboarding-modal 
      v-if="showContinueModal" 
      :rowData="selectedRowData" 
      :showModal="showContinueModal"
      @close-modal="closeContinueModal"
    /> -->

  </template>




    </dashboard-layout>
  </template>
  
  <script>
  import DashboardLayout from '@/components/DashboardLayout.vue';
  import OnboardBankMerchants from '@/modules/Sale-Executive-Portal/OnboardingModal.vue';
  import axios from 'axios'; 
  
  export default {
    name: 'bank-merchants',
  
    components: {
      DashboardLayout,
      OnboardBankMerchants
    },
  
    data() {
    return {

      showContinueModal: false,
      selectedRowData: {},
      fetchDataLoading: true,
      fetchPageData: false,
      currentPage: 1,
      rowsPerPage: 10,
      totalRows: 0,
      searchTerm: '',
      searchTerm2: '',

      hovered: false,
      showOnboardingModal0: false,
      onboardButtonClicked: false,
      businessType: '',
      businessName: '',
      email: '',
      taxNumber: '',
      phoneNumber: '',
      userID: '',
      withData: true,
      isDropdownOpen: false,
      cardSwitch: 'Onboarded',
      tableData: [],
      onboardedData: [],
      uploadedData:[],
      pendingData:[],
      showPopup: Array(3).fill(false),
      
    };
  },

  async mounted() {
    this.userID = sessionStorage.getItem('userId');
    document.addEventListener('click', this.closePopups);

    try{
      await this.fetchAllUploadedBankMerchants();
      this.fetchDataLoading = false;
    }catch(error){
      console.log(error);
    }
   
  },

  computed: {
    filteredRows() {
      const term = this.searchTerm.toLowerCase().trim();
      if (!term) return this.tableData;
      return this.tableData.filter(row =>
        Object.values(row).some(value =>
          value && value.toString().toLowerCase().includes(term)
        )
      );
    },
    visibleRows() {
    if (this.fetchPageData) {
      return []; // Show loader or empty data while fetching
    }

    // const startIndex = (this.currentPage - 1) * this.rowsPerPage;
    // const endIndex = startIndex + this.rowsPerPage;
    
    return this.tableData.slice(0, this.rowsPerPage); // Only use the new page's data
  },
    currentPageStart() {
      return Math.min((this.currentPage - 1) * this.rowsPerPage + 1, this.totalRows);
    },
    currentPageEnd() {
      return Math.min(this.currentPage * this.rowsPerPage, this.totalRows);
    }
  },

  methods: {

    navigateToDetails(row) {
    if (row.merchantId) {
      this.$router.push({
        path: '/sales/business/details',
        query: { MID: row.merchantId }
      });
    }
  },

  async fetchAllUploadedBankMerchants() {
    try {
      // Reset tableData when fetching new data
      this.tableData = [];
      this.fetchPageData = true;

      const response = await axios.get(`${this.$config.GETBANKMERCHANT_ENDPOINT}?PageNumber=${this.currentPage}&PageSize=${this.rowsPerPage}`,{
        headers: {
          Authorization: `Bearer ${this.$config.GETBANKMERCHANT_ENDPOINT_AUTHTOKEN}` 
        }
      });
      
      this.tableData = response.data.data;
      this.totalRows = response.data.totalCount;
      this.fetchPageData = false;
    } catch (error) {
      console.error('Error fetching Uploaded bank merchant details:', error);
      this.fetchPageData = false;
    }
  },
  async nextPage() {
    const totalPages = Math.ceil(this.totalRows / this.rowsPerPage);
    if (this.currentPage < totalPages) {
      this.currentPage++;
      await this.fetchAllUploadedBankMerchants();
    }
  },
  async prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      await this.fetchAllUploadedBankMerchants();
    }
  },

    openContinueModal(rowData) {
      this.selectedRowData = rowData; 
      this.showContinueModal = true;
    },
    async closeContinueModal() {
    //   this.fetchPendingOnboard()
      this.showContinueModal = false;
    },

    formatDate(dateTimeString) {
    const date = new Date(dateTimeString);
    const day = date.getDate().toString().padStart(2, '0'); // Ensure two digits for day
    const month = date.toLocaleString('en-US', { month: 'short' }); // Get short month name
    const year = date.getFullYear().toString(); // Get full year

    // Concatenate day, month, and year with hyphens
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
},


 



    toggleHover() {
            this.hovered = !this.hovered;
          
        },

        togglePopup(row) {
          this.tableData.forEach(row => {
        row.showPopup = false;
      });
          console.log('popup clicked', row);
    // Check if the row already has the showPopup property
    if (!Object.prototype.hasOwnProperty.call(row, 'showPopup')) {
      // If not, add it with an initial value of false
      this.$set(row, 'showPopup', false);
    }
    // Toggle the showPopup value for the corresponding row
    row.showPopup = !row.showPopup;
  },


    closePopups() {

      console.log('Close popup clicked');
      // Close all popups
      this.tableData.forEach(row => {
        row.showPopup = false;
      });
    },

   

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
      if (this.isDropdownOpen) {
        this.$refs.dropdown.focus();
      }
    },

    closeOnboardingModal0() {
      this.showOnboardingModal0 = false;
    },

    closeOnboardingModal1() {
      this.onboardButtonClicked = false;
    },

    openOnboardingModal1() {
      this.onboardButtonClicked = true;
    },

    openOnboardingModal0() {
      this.showOnboardingModal0 = true;
      this.onboardButtonClicked = true;
     
    },
   
  },
  
  };
  </script>
  
  <style>

.loaderPage {
  width: auto;
  height: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 500px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 3px solid #6F48FF;
  animation:
    l20-1 0.8s infinite linear alternate,
    l20-2 1.6s infinite linear;
}

.loader {
  width: auto;
  height: 30px;
  margin-top: 220px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 3px solid #6F48FF;
  animation:
    l20-1 0.8s infinite linear alternate,
    l20-2 1.6s infinite linear;
}
@keyframes l20-1{
   0%    {clip-path: polygon(50% 50%,0       0,  50%   0%,  50%    0%, 50%    0%, 50%    0%, 50%    0% )}
   12.5% {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100%   0%, 100%   0%, 100%   0% )}
   25%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 100% 100%, 100% 100% )}
   50%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
   62.5% {clip-path: polygon(50% 50%,100%    0, 100%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
   75%   {clip-path: polygon(50% 50%,100% 100%, 100% 100%,  100% 100%, 100% 100%, 50%  100%, 0%   100% )}
   100%  {clip-path: polygon(50% 50%,50%  100%,  50% 100%,   50% 100%,  50% 100%, 50%  100%, 0%   100% )}
}
@keyframes l20-2{ 
  0%    {transform:scaleY(1)  rotate(0deg)}
  49.99%{transform:scaleY(1)  rotate(135deg)}
  50%   {transform:scaleY(-1) rotate(0deg)}
  100%  {transform:scaleY(-1) rotate(-135deg)}
}

  
  </style>
  